import { ThemeOptions } from '@mui/material';
import { radius } from 'themes/radius';

export const generateCardThemeOptions = (): ThemeOptions['components'] => ({
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: radius.xxs,
      },
    },
  },
});
